import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=31801b81&scoped=true&"
import script from "./JobForm.vue?vue&type=script&lang=js&"
export * from "./JobForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31801b81",
  null
  
)

export default component.exports